var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryInverter = function SvgCategoryInverter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDC4CB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.333,
    d: "M32.58 4.093c.48.486.75 1.145.75 1.833v28.148c0 .688-.27 1.347-.75 1.834a2.55 2.55 0 0 1-1.814.759H9.23a2.55 2.55 0 0 1-1.813-.76 2.6 2.6 0 0 1-.751-1.833V5.926c0-.688.27-1.347.75-1.833a2.55 2.55 0 0 1 1.814-.76h21.536c.68 0 1.332.274 1.813.76M33.333 8.334h3.333M33.333 31.667h3.333M3.333 8.334h3.333M3.333 31.667h3.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDC4CB",
    strokeLinejoin: "round",
    strokeWidth: 3.333,
    d: "M13.333 10h13.333v5H13.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDC4CB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.333,
    d: "M13.333 24.445c1.285-.665 2.5-1.111 4.103-1.111 2.05 0 3.076 1.666 5.128 1.666 1.957 0 2.817-.446 4.102-1.11M13.333 29.445c1.285-.665 2.5-1.111 4.103-1.111 2.05 0 3.076 1.666 5.128 1.666 1.957 0 2.817-.446 4.102-1.11"
  })));
};
export default SvgCategoryInverter;